export const SideMenu = {
  DEVELOPMENT_WORK: {
    key: "VIKASKAME",
    label: "Development Work",
    icon: "pi pi-pw pi-chart-bar",
    link: "/vikas-kame/list",
    rank: 1,
  },
  MLA_FUND_MGMT: {
    key: "MLA_FUND_MGMT",
    label: "MLA Fund",
    icon: "fa fa-fw fa-inr",
    link: "/mla-fund-mgmt/list",
    rank: 2,
  },
  OFFICE: {
    key: "OFFICE",
    label: "Office",
    icon: "pi pi-pw pi-briefcase",
    link: "/office/list",
    rank: 3,
  },
  ADHIKARI: {
    key: "ADHIKARI",
    label: "Officer",
    icon: "pi pi-pw pi-user-plus",
    link: "/adhikari/list",
    rank: 4,
  },
  CONNECTOR: {
    key: "CONNECTOR",
    label: "Connector",
    icon: "pi pi-pw pi-user-minus",
    link: "/connector/list",
    rank: 5,
  },
  KARYAKARTA: {
    key: "KARYAKARTAS",
    label: "Karyakarta",
    icon: "pi pi-pw pi-user",
    link: "karyakarta/list",
    rank: 6,
  },
  DUARA: {
    key: "DUARA",
    label: "Tour",
    icon: "pi pi-pw pi-calendar-plus",
    link: "duara/list",
    rank: 7,
  },
  REPOSITORY: {
    key: "REPOSITORY",
    label: "Repository",
    icon: "pi pi-pw pi-file",
    link: "/repository/list",
    rank: 8,
  },
  PUBLIC_ENQUIRY: {
    key: "PUBLIC_ENQUIRY",
    label: "Public Enquiry",
    icon: "pi pi-pw pi-users",
    link: "/enquiry/container",
    rank: 9,
  },
  SUPERADMIN_CREATE: {
    key: "SUPERADMIN_CREATE",
    label: "Super Admin Create",
    icon: "pi pi-pw pi-users",
    link: "/super-admin",
    rank: 10,
  },
  MANAGE_VIEWER: {
    key: "MANAGE_VIEWER",
    label: "Manage Viewer",
    icon: "pi pi-pw pi-eye",
    link: "/user/viewer/list",
    rank: 11,
  },
  MESSAGE_PANNEL: {
    key: "MESSAGE_PANNEL",
    label: "Message Pannel",
    icon: "pi pi-pw pi-envelope",
    link: "/message-pannel/send-message",
    rank: 12,
  },
  IMPORT_VOTER_DATA: {
    key: "IMPORT_VOTER_DATA",
    label: "Import Voter Data",
    icon: "pi pi-pw pi-upload",
    link: "/import-voter",
    rank: 13,
  },
  VOTER_SEARCH: {
    key: "VOTER_SEARCH",
    label: "Voter Search",
    icon: "pi pi-pw pi-search",
    link: "/voter/search",
    rank: 14,
  },
  REPORT: {
    key: "REPORT",
    label: "Report",
    icon: "pi pi-pw pi-file",
    link: "/report",
    rank: 15,
  },
  ADVERTISEMENT: {
    key: "ADVERTISEMENT",
    label: "Advertisement",
    icon: "pi pi-pw pi-camera",
    link: "/advertisement/list",
    rank: 16,
  },
  KIOSK: {
    key: "KIOSK",
    label: "kiosk",
    icon: "pi pi-pw pi-money-bill",
    link: "/kiosk-list",
    rank: 17,
  },
  USER_MGMT: {
    key: "USER_MGMT",
    label: "User Management",
    icon: "pi pi-pw pi-users",
    link: "/manage-user/user-mgmt-list",
  },
};

export const TopBarMenu = {
  DASHBOARD: {
    key: "DASHBOARD",
    label: "Dashboard",
    icon: "pi pi-pw pi-home pi-th-large",
    link: "/admin-dashboard",
    rank: 1,
  },
  SUPER_ADMIN_DASHBOARD: {
    key: "SUPER_ADMIN_DASHBOARD",
    label: "Dashboard",
    icon: "pi pi-pw pi-home pi-th-large",
    link: "/admin-dashboard",
    rank: 1,
  },
  SYSTEM_ADMIN_DASHBOARD: {
    key: "DASHBOARD",
    label: "Dashboard",
    icon: "pi pi-pw pi-home pi-th-large",
    link: "/admin-dashboard",
    rank: 1,
  },
  OFFICE_ADMIN_DASHBOARD: {
    key: "DASHBOARD",
    label: "Dashboard",
    icon: "pi pi-pw pi-home pi-th-large",
    link: "/admin-dashboard",
    rank: 1,
  },
  KARYAKARTA_DASHBOARD: {
    key: "DASHBOARD",
    label: "Dashboard",
    icon: "pi pi-pw pi-home pi-th-large",
    link: "/karyakarta/dashboard",
    rank: 1,
  },
  VIEWER_DASHBOARD: {
    key: "DASHBOARD",
    label: "Dashboard",
    icon: "pi pi-pw pi-home pi-th-large",
    link: "/viewer-dashboard",
    rank: 1,
  },

  REGISTER_BOOK: {
    key: "REGISTER_BOOK",
    label: "Register",
    icon: "pi pi-pw pi-briefcase",
    link: "/register-book/list",
    rank: 2,
  },
  SCHEDULE_BOOK: {
    key: "SCHEDULE_BOOK",
    label: "Schedule",
    icon: "pi pi-pw pi-calendar",
    link: "/shedule-book/list",
    rank: 3,
  },
  COMPLAINTS: {
    key: "COMPLAINTS",
    label: "Complaints",
    icon: "pi pi-pw pi-info-circle",
    link: "/complain/list",
    rank: 4,
  },
  CALL_LOGS: {
    key: "CALL_LOGS",
    label: "Call Logs",
    icon: "pi pi-pw pi-comments",
    link: "/call-log",
    rank: 6,
  },
  VISITORS: {
    key: "VISITORS",
    label: "Visitors",
    icon: "pi pi-pw pi-users",
    link: "/visitor/list",
    rank: 5,
  },
};

export const SystemAdminTopBar = {
  DASHBOARD: {
    key: "DASHBOARD",
    label: "Dashboard",
    icon: "pi pi-pw pi-home pi-th-large",
    link: "/admin-dashboard",
    rank: 1,
  },
};

export const SystemSideMenu = {
  SUPERADMIN_CREATE: {
    key: "SUPERADMIN_CREATE",
    label: "Super Admin Create",
    icon: "pi pi-pw pi-users",
    link: "/super-admin",
    rank: 10,
  },
  IMPORT_VOTER_DATA: {
    key: "IMPORT_VOTER_DATA",
    label: "Import Voter Data",
    icon: "pi pi-pw pi-upload",
    link: "/import-voter",
    rank: 13,
  },
  USER_MGMT: {
    key: "USER_MGMT",
    label: "User Management",
    icon: "pi pi-pw pi-users",
    link: "/manage-user/user-mgmt-list",
  },
};
